import { render, staticRenderFns, recyclableRender, components } from "./word.vue?vue&type=template&id=0699912b&scoped=true&"
var renderjs
import script from "./word.vue?vue&type=script&lang=js&"
export * from "./word.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0699912b",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uce-course/pages/word/word.vue"
export default component.exports